// Coordonnées légales de la société éditrice. Source unique réutilisée par les
// pages légales, la page "Qui sommes-nous", la page Contact et le pied de page.
// NOTE: certaines valeurs (capital social, N° TVA) restent à confirmer par le
// client avant mise en production — elles sont clairement marquées.
export const COMPANY = {
  brand: "PlanPermis",
  legalName: "TETRISNEWS SAS",
  address: "149 avenue du Maine, 75014 Paris",
  siren: "941 137 432",
  rcs: "RCS Paris 941 137 432",
  email: "contact@planpermis.fr",
  phone: "+33 7 52 98 04 86",
  director: "Le représentant légal de TETRISNEWS SAS",
  host: "IONOS SARL — 7 place de la Gare, BP 70109, 57201 Sarreguemines Cedex, France (www.ionos.fr)",
  mediatorEmail: "thibaut.talom@tetrisnews.fr",
  capital: "100 €",
  tva: "FR37941137432",
};
